import { render, staticRenderFns } from "./player_data.vue?vue&type=template&id=93d33204"
import script from "./player_data.vue?vue&type=script&lang=js"
export * from "./player_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports